import React, { useEffect, useState } from 'react';
import { Car, Info, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const TravelInfo = ({ jobId, token, className = '' }) => {
  const [travel, setTravel] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const res = await fetch(`${API_URL}/api/jobs/${jobId}/travel/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = res.ok ? await res.json() : null;
        if (active) setTravel(data);
      } catch (err) {
        if (active) setTravel(null);
      } finally {
        if (active) setLoading(false);
      }
    };
    load();
    return () => { active = false; };
  }, [jobId, token]);

  if (loading) {
    return (
      <div className={`flex items-center gap-2 text-sm text-slate-400 ${className}`} data-testid={`travel-loading-${jobId}`}>
        <Loader2 className="w-4 h-4 animate-spin" />
        <span>Working out travel…</span>
      </div>
    );
  }

  if (!travel) return null;

  if (travel.status === 'ok' || travel.status === 'manual_only') {
    const money = travel.travel_money === null || travel.travel_money === undefined
      ? null
      : `£${Number(travel.travel_money).toFixed(2)}`;
    return (
      <div
        className={`flex items-start gap-2 text-sm bg-cream border border-hair rounded-[10px] p-2.5 ${className}`}
        data-testid={`travel-info-${jobId}`}
      >
        <Car className="w-4 h-4 text-gold-deep mt-0.5 flex-shrink-0" />
        <div>
          <p className="text-ink">
            <span className="font-medium">Travel: </span>
            {travel.distance_miles !== null && travel.distance_miles !== undefined && (
              <>{Number(travel.distance_miles).toFixed(1)} miles each way</>
            )}
            {travel.duration_text && <> · about {travel.duration_text}</>}
            {money && <> · <span className="font-semibold">{money} travel money</span></>}
          </p>
          {travel.is_manual && (
            <p className="text-xs text-gold-deep mt-0.5">Manual amount set by the office</p>
          )}
          {!travel.is_manual && travel.free_miles_per_leg !== undefined && (
            <p className="text-xs text-slate-500 mt-0.5">
              First {travel.free_miles_per_leg} miles each way unpaid, then £{Number(travel.rate_per_mile).toFixed(2)} per mile
            </p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div
      className={`flex items-start gap-2 text-sm text-slate-500 bg-slate-50 border border-slate-200 rounded-lg p-2.5 ${className}`}
      data-testid={`travel-message-${jobId}`}
    >
      <Info className="w-4 h-4 mt-0.5 flex-shrink-0" />
      <span>{travel.message}</span>
    </div>
  );
};

export default TravelInfo;
